import React, { useState, useMemo } from 'react';
import { Link } from 'react-router-dom';
import { Gamepad2, ChevronLeft } from 'lucide-react';

import { GAMES_DATA } from '../data/games';
import GameCard from '../components/GameCard';

// Every tag used across the games, in the order they first appear.
const ALL_TAGS = [...new Set(GAMES_DATA.flatMap(game => game.tags))];

export default function GamesPage() {
  const [activeTag, setActiveTag] = useState(null);

  const visibleGames = useMemo(
    () => (activeTag ? GAMES_DATA.filter(game => game.tags.includes(activeTag)) : GAMES_DATA),
    [activeTag]
  );

  return (
    <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">

      <Link
        to="/"
        className="inline-flex items-center gap-1 text-sm font-medium text-slate-500 hover:text-rose-600 transition-colors mb-6"
      >
        <ChevronLeft size={16} />
        Back to the collection
      </Link>

      <div className="mb-8">
        <h2 className="text-3xl font-extrabold tracking-tight text-slate-800 flex items-center gap-3">
          <Gamepad2 size={28} className="text-rose-500" />
          Games
        </h2>
        <p className="text-slate-500 mt-2 max-w-2xl">
          Homemade browser games, playable on a keyboard or by touch on a tablet.
          Nothing to install: pick one and it opens in a new tab.
        </p>
      </div>

      {/* Tag filter */}
      <div className="mb-8 flex flex-wrap gap-2">
        <button
          onClick={() => setActiveTag(null)}
          className={`text-sm px-3 py-1.5 rounded-full font-medium border transition-colors ${
            activeTag === null
              ? 'bg-rose-500 text-white border-rose-500'
              : 'bg-white text-slate-600 border-slate-200 hover:border-rose-200 hover:text-rose-600'
          }`}
        >
          All {GAMES_DATA.length}
        </button>
        {ALL_TAGS.map(tag => (
          <button
            key={tag}
            onClick={() => setActiveTag(tag === activeTag ? null : tag)}
            className={`text-sm px-3 py-1.5 rounded-full font-medium border transition-colors ${
              tag === activeTag
                ? 'bg-rose-500 text-white border-rose-500'
                : 'bg-white text-slate-600 border-slate-200 hover:border-rose-200 hover:text-rose-600'
            }`}
          >
            {tag}
          </button>
        ))}
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
        {visibleGames.map(game => (
          <GameCard key={game.id} game={game} size="large" />
        ))}
      </div>

    </main>
  );
}
